<template>
  <div class="container">
        <div class="card text-dark text-left">
            <div class="card-header font-weight-bold">
                <h3>Add Item</h3>
                <a>
                  <router-link to="/viewlistvedio">
                    <img class="image col-xs-3" id="exit" src="@/assets/exit.png" height="35" width="35" alt="" />
                  </router-link> 
                </a> 
            </div>
            <div class="card-body">
                <form v-on:submit.prevent="addItem">
                    <div class="form-group">
                        <label>Category:</label>
                        <input type="text" class="form-control" v-model="newItem.category"/>
                    </div>
                     <div class="form-group">
                        <label>Channel:</label>
                        <input type="text" class="form-control" v-model="newItem.channel"/>
                    </div>
                    <div class="form-group">
                        <label>Channel ID:</label>
                        <input type="text" class="form-control" v-model="newItem.channelid"/>
                    </div>
                     <div class="form-group">
                        <label>Feed:</label>
                        <input type="text" class="form-control" v-model="newItem.feed"/>
                    </div>
                    <div class="form-group">
                        <label>YQL:</label>
                        <input type="text" class="form-control" v-model="newItem.yql"/>
                    </div>
                    <!--<div class="form-group">
                        <label>Is Active?</label>
                        <input type="radio" class="form-control" v-model="newItem.isactive"/>
                    </div>-->
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" data-toggle="toggle" v-model="newItem.isactive">
                            Is Active?
                        </label>
                    </div>


                    <div class="form-group">
                        <input type="submit" class="btn btn-primary" value="Add Item"/>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import router from '../router'
import firebase from 'firebase'
import { db } from '../main';

export default {
  components: {
      name: 'Additem'
  },
  firestore () {
    items: db.collection('channels')
  },
  data () {
    return {
      newItem: {
          category: '',
          channel: '',
          channelid: '',
          feed: '',
          isactive: null,
          yql:''
      }
    }
  },
  methods: {
      addItem() {
/*This is for firestore */
        db.collection('channels').add({
            category: this.newItem.category,
            channel: this.newItem.channel,
            channelid: this.newItem.channelid,
            feed: this.newItem.feed,
            isactive: this.newItem.isactive,
            yql: this.newItem.yql
        });

/*This is for firebase realtime database.
        this.$firebaseRefs.items.push({
            category: this.newItem.category,
            channel: this.newItem.channel,
            channelid: this.newItem.channelid,
            feed: this.newItem.feed,
            isactive: this.newItem.isactive,
            yql: this.newItem.yql
        });
*/  
        alert('Add Successfully!');
        this.newItem.category = '';
        this.newItem.channel = '';
        this.newIte.channelid = '';
        this.newItem.feed = '';
        this.newItem.isactive = true;
        this.newItem.yql = '';
        this.$router.push('/')
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/additem.vue